/*
 * ---------------------------------------------------------------------------
 * RESPALDO DEL POP-UP PROMOCIONAL  (Blisse)
 *
 * Contexto: el archivo original assets/shrine.js quedo vacio (0 bytes) el
 * 2025-11-25. Ese archivo contenia, entre otras cosas, la definicion del
 * custom element <promo-popup>. Sin el, el HTML del pop-up se renderiza pero
 * nunca se abre.
 *
 * Este archivo NO reemplaza a shrine.js. Solo restituye el comportamiento del
 * pop-up de captura de correos, leyendo la misma configuracion que ya tienes
 * en el personalizador del tema (delay, frecuencia, temporizador).
 *
 * Es auto-anulable: si algun dia se restaura el shrine.js original, este
 * codigo detecta que <promo-popup> ya esta definido y no hace nada.
 *
 * PENDIENTE: restaurar el shrine.js original para reparar cart-drawer,
 * product-form y predictive-search, que siguen sin codigo.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var FLAG = 'popupFallbackActivo';

  function iniciar() {
    var root = document.querySelector('promo-popup');
    if (!root) return;

    // Si el shrine.js original volvio, no interferimos.
    if (window.customElements && window.customElements.get('promo-popup')) return;
    if (root.constructor && root.constructor !== window.HTMLElement) return;

    // Evita doble inicializacion (p. ej. si la seccion se recarga en el editor).
    if (root.dataset[FLAG] === 'si') return;
    root.dataset[FLAG] = 'si';

    var modal = root.querySelector('.sign-up-popup-modal');
    var overlay = root.querySelector('.sign-up-popup-overlay');
    if (!modal || !overlay) return;

    var modoPrueba = root.dataset.testMode === 'true';
    var segundos = parseFloat(root.dataset.delaySeconds) || 5;
    var dias = parseFloat(root.dataset.delayDays) || 30;
    var mostrarTimer = root.dataset.displayTimer === 'true';
    var minutosTimer = parseFloat(root.dataset.timerDuration) || 3;

    var host = window.location.host;
    var claveCerrado = 'promo-popup-dismissed-' + host;
    // Misma clave que usa el script de exito ya presente en la seccion.
    var claveSuscrito = 'promo-bar-subscribed-' + host;

    function leer(clave) {
      try {
        return window.localStorage.getItem(clave);
      } catch (e) {
        return null;
      }
    }

    function guardar(clave, valor) {
      try {
        window.localStorage.setItem(clave, valor);
      } catch (e) {
        /* modo privado o storage lleno: no es critico */
      }
    }

    function debeMostrarse() {
      if (modoPrueba) return true;
      if (leer(claveSuscrito)) return false;
      var ultimo = parseInt(leer(claveCerrado), 10);
      if (!ultimo) return true;
      return Date.now() - ultimo > dias * 86400000;
    }

    var intervaloTimer = null;

    function arrancarTimer() {
      if (!mostrarTimer) return;
      var elMin = modal.querySelector('.popup-modal__timer__minutes');
      var elSeg = modal.querySelector('.popup-modal__timer__seconds');
      if (!elMin || !elSeg) return;

      var restante = Math.round(minutosTimer * 60);

      function pintar() {
        var m = Math.floor(restante / 60);
        var s = restante % 60;
        elMin.textContent = (m < 10 ? '0' : '') + m;
        elSeg.textContent = (s < 10 ? '0' : '') + s;
        if (restante <= 0) {
          clearInterval(intervaloTimer);
          intervaloTimer = null;
          return;
        }
        restante--;
      }

      pintar();
      intervaloTimer = setInterval(pintar, 1000);
    }

    function abrir() {
      modal.classList.add('popup-modal--active');
      overlay.classList.add('popup-overlay--active');
      arrancarTimer();
    }

    function cerrar() {
      modal.classList.remove('popup-modal--active');
      overlay.classList.remove('popup-overlay--active');
      if (intervaloTimer) {
        clearInterval(intervaloTimer);
        intervaloTimer = null;
      }
      if (!modoPrueba) guardar(claveCerrado, String(Date.now()));
    }

    // Overlay, boton X y boton "No, Gracias" comparten esta clase en el tema.
    var cerradores = root.querySelectorAll('.promp-popup__close-btn');
    for (var i = 0; i < cerradores.length; i++) {
      cerradores[i].addEventListener('click', cerrar);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (modal.classList.contains('popup-modal--active')) cerrar();
    });

    if (debeMostrarse()) {
      setTimeout(abrir, segundos * 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
